/**
 * Utilidades DOM mínimas (sin framework): árboles legibles y tipados.
 */

export type AttrMap = Record<string, string | boolean | undefined>;

export function createEl<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: AttrMap = {},
  children?: Array<Node | string | undefined | null | false>
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);

  for (const [key, value] of Object.entries(attrs)) {
    if (value === undefined || value === false) {
      continue;
    }
    const str = String(value);
    if (key === 'class' || key === 'className') {
      el.className = str;
      continue;
    }
    if (key === 'textContent') {
      el.textContent = str;
      continue;
    }
    el.setAttribute(key, str);
  }

  for (const child of children ?? []) {
    if (child == null || child === false) {
      continue;
    }
    el.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
  }
  return el;
}

export function frag(...nodes: Array<Node | string | undefined | null | false>): DocumentFragment {
  const f = document.createDocumentFragment();
  for (const n of nodes) {
    if (n == null || n === false) {
      continue;
    }
    f.appendChild(typeof n === 'string' ? document.createTextNode(n) : n);
  }
  return f;
}
